import React from "react";
import { LightButton } from "./element";
import { SiGitbook } from "react-icons/si";

interface BtnProps {
  btnText: string;
  navigate?: string;
  bookIcon?: boolean;
}

const LightBtnCom: React.FC<BtnProps> = ({ btnText, navigate, bookIcon }) => {
  const handleButtonClick = () => {
    if (navigate === "gitbook") {
      window.open("https://www.gitbook.com", "_blank");
    }
  };

  return (
    <LightButton onClick={handleButtonClick}>
      {bookIcon && <SiGitbook className="book-icon" />}
      {btnText}
    </LightButton>
  );
};

export default LightBtnCom;
